/* CALIMPORT THEME v5 — Carrito Cotizador */
var CLM_KEY = 'clm_quote_cart';

function clmGetCart() { try { return JSON.parse(localStorage.getItem(CLM_KEY))||[]; } catch(e){ return []; } }
function clmSaveCart(c) { localStorage.setItem(CLM_KEY, JSON.stringify(c)); }

function clmAddToCart(p) {
  var cart=clmGetCart(), idx=cart.findIndex(function(x){return x.id===p.id;});
  if(idx>-1){cart[idx].qty=(cart[idx].qty||1)+1;}else{p.qty=1;cart.push(p);}
  clmSaveCart(cart); clmUpdateBadge(); clmShowNotif(p.title);
}
function clmRemove(id){ clmSaveCart(clmGetCart().filter(function(p){return p.id!==id;})); clmUpdateBadge(); clmRenderSidebar(); clmRenderQuotePage(); }
function clmSetQty(id,qty){ var cart=clmGetCart(),idx=cart.findIndex(function(p){return p.id===id;}); if(idx>-1){cart[idx].qty=Math.max(1,parseInt(qty)||1);clmSaveCart(cart);} clmRenderSidebar(); clmRenderQuotePage(); }
function clmClear(){ clmSaveCart([]); clmUpdateBadge(); clmRenderSidebar(); clmRenderQuotePage(); }

function clmUpdateBadge(){
  var n=clmGetCart().reduce(function(s,p){return s+(p.qty||1);},0);
  document.querySelectorAll('.clm-badge').forEach(function(b){b.textContent=n;b.style.display=n>0?'flex':'none';});
}

function clmShowNotif(title){
  var n=document.getElementById('clm-notif'); if(!n)return;
  n.querySelector('.clm-notif__title').textContent='\u00a1Agregado a cotizaci\u00f3n!';
  n.querySelector('.clm-notif__sub').textContent=title;
  n.classList.add('show'); clearTimeout(n._t);
  n._t=setTimeout(function(){n.classList.remove('show');},3000);
}

function clmRenderSidebar(){
  var sb=document.getElementById('clm-sidebar'); if(!sb)return;
  var cart=clmGetCart(), list=sb.querySelector('.clm-sidebar__list'), empty=sb.querySelector('.clm-sidebar__empty'), foot=sb.querySelector('.clm-sidebar__footer');
  if(!list)return;
  if(cart.length===0){ list.innerHTML=''; if(empty)empty.style.display='flex'; if(foot)foot.style.display='none'; return; }
  if(empty)empty.style.display='none'; if(foot)foot.style.display='block';
  list.innerHTML=cart.map(function(p){
    var img=p.image?'<img src="'+p.image+'" alt="'+p.title+'" style="width:52px;height:52px;object-fit:contain;border-radius:6px;background:#EFF6FF;flex-shrink:0;">':'<div style="width:52px;height:52px;background:#EFF6FF;border-radius:6px;flex-shrink:0;"></div>';
    return '<div class="clm-sidebar__item">'+img+'<div class="clm-sidebar__item-info"><div class="clm-sidebar__item-title">'+p.title+'</div>'+(p.sku?'<div class="clm-sidebar__item-sku">SKU: '+p.sku+'</div>':'')+(p.vendor?'<div class="clm-sidebar__item-sku">'+p.vendor+'</div>':'')+'</div><div class="clm-sidebar__item-ctrl"><input type="number" min="1" value="'+(p.qty||1)+'" class="clm-s-qty" data-id="'+p.id+'" style="width:48px;padding:4px;border:1px solid #E5E7EB;border-radius:4px;text-align:center;font-size:13px;"><button class="clm-s-rm" data-id="'+p.id+'" style="background:none;border:none;color:#9CA3AF;font-size:20px;cursor:pointer;padding:0 4px;">&times;</button></div></div>';
  }).join('');
  list.querySelectorAll('.clm-s-qty').forEach(function(i){i.addEventListener('change',function(){clmSetQty(this.dataset.id,this.value);});});
  list.querySelectorAll('.clm-s-rm').forEach(function(b){b.addEventListener('click',function(){clmRemove(this.dataset.id);});});
}

function clmRenderQuotePage(){
  var wrap=document.getElementById('clm-quote-products'); if(!wrap)return;
  var cart=clmGetCart();
  var inp=document.getElementById('clm-products-hidden');
  var btn=document.getElementById('clm-cot-submit');
  var hint=document.getElementById('clm-hint');

  if(cart.length===0){
    wrap.innerHTML='<div style="text-align:center;padding:32px 0;"><svg viewBox="0 0 24 24" fill="none" stroke="#E5E7EB" stroke-width="1.5" width="48" height="48" style="margin:0 auto 12px;display:block;"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/></svg><p style="font-size:13px;color:#9CA3AF;">Sin productos.<br><a href="/collections/all" style="color:#F26522;font-weight:700;">Ir al cat\u00e1logo</a></p></div>';
    if(inp)inp.value='';
    if(btn){btn.disabled=true;btn.style.opacity='.5';btn.style.cursor='not-allowed';}
    if(hint)hint.style.display='block';
    return;
  }

  if(btn){btn.disabled=false;btn.style.opacity='1';btn.style.cursor='pointer';}
  if(hint)hint.style.display='none';

  wrap.innerHTML=cart.map(function(p){
    var img=p.image
      ?'<img src="'+p.image+'" alt="'+p.title+'" style="width:60px;height:60px;object-fit:contain;border-radius:8px;background:#EFF6FF;padding:4px;flex-shrink:0;">'
      :'<div style="width:60px;height:60px;background:#EFF6FF;border-radius:8px;flex-shrink:0;"></div>';
    return '<div class="clm-qp__item">'+img+'<div class="clm-qp__info"><div class="clm-qp__title">'+p.title+'</div><div class="clm-qp__meta">'+(p.sku?'<span class="clm-qp__tag">SKU: '+p.sku+'</span>':'')+(p.vendor?'<span class="clm-qp__tag clm-qp__tag--blue">'+p.vendor+'</span>':'')+'</div></div><div class="clm-qp__qty"><div style="font-size:10px;color:#9CA3AF;margin-bottom:3px;text-transform:uppercase;letter-spacing:.5px;">Cant.</div><input type="number" min="1" value="'+(p.qty||1)+'" class="clm-qp-qty" data-id="'+p.id+'" style="width:56px;padding:5px;border:1.5px solid #E5E7EB;border-radius:6px;text-align:center;font-size:14px;font-weight:700;"></div><button class="clm-qp-rm" data-id="'+p.id+'" style="background:none;border:1px solid #E5E7EB;border-radius:6px;color:#9CA3AF;font-size:16px;cursor:pointer;width:30px;height:30px;display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:all .2s;">&times;</button></div>';
  }).join('');

  wrap.querySelectorAll('.clm-qp-qty').forEach(function(i){
    i.addEventListener('change',function(){clmSetQty(this.dataset.id,this.value);});
  });
  wrap.querySelectorAll('.clm-qp-rm').forEach(function(b){
    b.addEventListener('click',function(){clmRemove(this.dataset.id);});
    b.addEventListener('mouseover',function(){this.style.borderColor='#F26522';this.style.color='#F26522';});
    b.addEventListener('mouseout',function(){this.style.borderColor='#E5E7EB';this.style.color='#9CA3AF';});
  });

  /* ----------------------------------------------------------------
   * Campo oculto para el email
   * Formato por producto:
   *   [1] NOMBRE DEL PRODUCTO
   *       SKU: 123456 | Marca: ABB | Cantidad: 2
   *       https://tienda.com/products/producto
   * ---------------------------------------------------------------- */
  if(inp){
    var shop = 'https://' + window.location.host;
    var separator = '\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500';
    var lines = cart.map(function(p, i){
      var block = '';
      block += '[' + (i+1) + '] ' + p.title.toUpperCase() + '\n';
      /* Segunda linea: SKU | Marca | Cantidad */
      var meta = [];
      meta.push('SKU: ' + (p.sku && p.sku.trim() ? p.sku : 'sin SKU'));
      if(p.vendor) meta.push('Marca: ' + p.vendor);
      meta.push('Cantidad: ' + (p.qty||1));
      block += '    ' + meta.join('  |  ') + '\n';
      /* Tercera linea: URL clicable */
      if(p.url) block += '    ' + shop + p.url;
      return block;
    });
    inp.value = lines.join('\n' + separator + '\n');
  }
}

document.addEventListener('DOMContentLoaded',function(){

  /* Fade-in scroll */
  if('IntersectionObserver' in window){
    var obs=new IntersectionObserver(function(e){e.forEach(function(x){if(x.isIntersecting){x.target.classList.add('visible');obs.unobserve(x.target);}});},{threshold:.1,rootMargin:'0px 0px -30px 0px'});
    document.querySelectorAll('.clm-fade').forEach(function(el,i){el.style.transitionDelay=(i%4*.08)+'s';obs.observe(el);});
  }else{document.querySelectorAll('.clm-fade').forEach(function(el){el.classList.add('visible');});}

  /* Tilt 3D en cards */
  document.querySelectorAll('.product-card').forEach(function(c){
    c.addEventListener('mousemove',function(e){var r=c.getBoundingClientRect(),x=e.clientX-r.left-r.width/2,y=e.clientY-r.top-r.height/2;c.style.transform='translateY(-6px) rotateX('+(y/r.height*4)+'deg) rotateY('+-(x/r.width*4)+'deg)';c.style.transition='transform .1s ease';});
    c.addEventListener('mouseleave',function(){c.style.transform='';c.style.transition='all .35s cubic-bezier(.4,0,.2,1)';});
  });

  /* Counter-up */
  if('IntersectionObserver' in window){
    var sObs=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){var el=e.target,t=parseInt(el.dataset.target,10),s=0,step=t/80;var tm=setInterval(function(){s=Math.min(s+step,t);el.textContent=Math.round(s);if(s>=t)clearInterval(tm);},16);sObs.unobserve(el);}});},{threshold:.5});
    document.querySelectorAll('[data-counter]').forEach(function(el){sObs.observe(el);});
  }

  /* Mobile menu */
  var mb=document.getElementById('mobile-menu-btn'),mn=document.getElementById('mobile-nav');
  if(mb&&mn)mb.addEventListener('click',function(){mn.classList.toggle('open');});

  /* Botones agregar a cotizaci\u00f3n */
  document.querySelectorAll('[data-quote-add]').forEach(function(btn){
    btn.addEventListener('click',function(e){
      e.preventDefault();
      clmAddToCart({
        id:     this.dataset.id,
        title:  this.dataset.title,
        sku:    this.dataset.sku    || '',
        vendor: this.dataset.vendor || '',
        image:  this.dataset.image  || '',
        url:    this.dataset.url    || ''
      });
    });
  });

  /* Sidebar */
  var sb=document.getElementById('clm-sidebar'),ov=document.getElementById('clm-overlay');
  function closeSB(){if(sb)sb.classList.remove('open');if(ov)ov.classList.remove('show');document.body.style.overflow='';}
  document.querySelectorAll('[data-quote-toggle]').forEach(function(btn){
    btn.addEventListener('click',function(e){
      e.preventDefault(); if(!sb)return;
      sb.classList.toggle('open');if(ov)ov.classList.toggle('show');
      document.body.style.overflow=sb.classList.contains('open')?'hidden':'';
      clmRenderSidebar();
    });
  });
  if(ov)ov.addEventListener('click',closeSB);
  var cBtn=document.getElementById('clm-sb-close');if(cBtn)cBtn.addEventListener('click',closeSB);
  var goBtn=document.getElementById('clm-sb-go');
  if(goBtn)goBtn.addEventListener('click',function(){closeSB();window.location.href='/pages/cotizacion';});

  clmUpdateBadge();
  clmRenderQuotePage();
});
